import React, { useEffect, useState } from 'react'
import { Alert, Button, Drawer, Form, Input, message, notification, Popconfirm } from 'antd'
import {
    PlusOutlined,
    EditOutlined,
    SaveOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import Container from '../../../components/Container'
import Main from '../../../components/Main'
import PageHeader from '../../../components/PageHeader'
import AgoraTable from '../../../components/Table';
import { useAuthUser } from 'react-auth-kit';
import axios from 'axios';

function DocumentType() {
    const auth = useAuthUser()
    const [docTypeForm] = Form.useForm();
    const [state, setState] = useState({
        gvDocTypeLoading: false,
        gvDocType: [],
        formOpen: false,
        formType: "Add",
        btnSubmitLoading: false,
        btnSubmitResStatus: "",
        btnSubmitResMsg: "",
        btnDeleteLoading: false,
    })
    const handleSetState = (newState) => {
        setState(prevState => ({
            ...prevState,
            ...newState,
        }))
    }
    useEffect(() => {
        getDocTypePageLoad()
        // eslint-disable-next-line
    }, [])
    const getDocTypePageLoad = () => {
        handleSetState({ gvDocTypeLoading: true })
        axios.get(`/DocumentType/PageLoad`).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    gvDocTypeLoading: false,
                    gvDocType: resData.Data.gvDocumentType
                })
            } else {
                message.error(resData.Message)
            }
        }).catch(error => {
            console.log(error)
            message.error(error.message)
        })
    }
    const handleOnFinishDocType = (formData) => {
        handleSetState({ btnSubmitLoading: true })
        if (state.formType === "Add") {
            axios.post(`/DocumentType/Create`, {
                docTypeCode: formData.docTypeCode,
                docTypeDesc: formData.docTypeDesc,
                createdBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getDocTypePageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        } else if (state.formType === "Edit") {
            axios.post(`/DocumentType/Update`, {
                docTypeId: formData.docTypeId,
                docTypeCode: formData.docTypeCode,
                docTypeDesc: formData.docTypeDesc,
                modifiedBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getDocTypePageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        }

    }
    const handleOnDeleteDocType = () => {
        handleSetState({ btnDeleteLoading: true })
        axios.post(`/DocumentType/Delete`, {
            docTypeId: docTypeForm.getFieldValue("docTypeId"),
            modifiedBy: auth().userId,
        }).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    formOpen: false,
                    btnDeleteLoading: false
                });
                getDocTypePageLoad();
                notification.success({
                    message: "Successful",
                    description: resData.Message
                });
            } else {
                handleSetState({
                    btnDeleteLoading: false,
                    btnSubmitResStatus: resData.Status,
                    btnSubmitResMsg: resData.Message,
                });
            }
        }).catch(error => {
            console.log(error);
            message.error(error.message);
        })

    }

    const isAllowToManage = () => {
        if (auth().role === "Admin") {
            return true
        }
        return false;
    }

    return (
        <Main listBreadcrumb={[
            { key: "1", title: "Maintenance" },
            { key: "2", title: "Library" },
            { key: "3", title: "Document Type" },
        ]}>
            <Container>
                <PageHeader title="Document Type" subtitle="List of document type details.">
                    {isAllowToManage() &&
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                docTypeForm.resetFields();
                                handleSetState({
                                    formOpen: true,
                                    formType: "Add",
                                })
                            }}
                        >
                            New Document Type
                        </Button>
                    }
                </PageHeader>
                <AgoraTable
                    loading={state.gvDocTypeLoading}
                    dataSource={state.gvDocType}
                    rowKey="docTypeId"
                    columns={[
                        {
                            title: 'Document Type Code',
                            dataIndex: 'docTypeCode',
                            key: 'docTypeCode',
                            dataType: "text",
                            render: (text, record) => <div className="i-x-space-between">
                                <div>{text || "-"}</div>
                                <div className="i-x-right">
                                    {isAllowToManage() &&
                                        <Button className="table-btn edit" size="small" style={{ marginRight: "10px" }}
                                            onClick={() => {
                                                docTypeForm.setFieldsValue({
                                                    docTypeId: record.docTypeId,
                                                    docTypeCode: record.docTypeCode,
                                                    docTypeDesc: record.docTypeDesc,
                                                });
                                                handleSetState({
                                                    formOpen: true,
                                                    formType: "Edit",
                                                })
                                            }}
                                        ><EditOutlined /> Edit</Button>
                                    }
                                </div>
                            </div>,
                        },
                        {
                            title: 'Description',
                            dataIndex: 'docTypeDesc',
                            key: 'docTypeDesc',
                            dataType: "text",
                            render: (text) => text || "-",
                        },
                    ]}
                />
            </Container>
            <Drawer title={`${state.formType} Document Type`}
                width={window.innerWidth > 500 ? 500 : window.innerWidth - 80}
                open={state.formOpen}
                extra={
                    <Button type="primary"
                        loading={state.btnSubmitLoading}
                        onClick={() => docTypeForm.submit()}
                        icon={state.formType === "Add" ? <PlusOutlined /> : <SaveOutlined />}
                    >
                        {state.formType === "Add" ? "Add" : "Update"}
                    </Button>
                }
                onClose={() => {
                    docTypeForm.resetFields()
                    handleSetState({
                        formType: "Add",
                        formOpen: false,
                        btnSubmitResStatus: "",
                        btnSubmitResMsg: "",
                    })
                }}
            >
                <div className="i-y-100 i-y-space-between">
                    <Form
                        form={docTypeForm}
                        name="doc-type-form"
                        layout="vertical"
                        size="middle"
                        requiredMark={false}
                        onFinish={handleOnFinishDocType}
                    >
                        {state.btnSubmitResStatus !== ""
                            && <Alert type="error" showIcon style={{ margin: "0px 25px 20px 0px" }}
                                message={state.btnSubmitResMsg}
                            />
                        }
                        <Form.Item hidden={true} name="docTypeId" ></Form.Item>
                        <Form.Item
                            label="Document Type Code"
                            name="docTypeCode"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter document type code!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., DCA' />
                        </Form.Item>
                        <Form.Item
                            label="Description"
                            name="docTypeDesc"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter document type description!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., Direct Credit Authorisation Form (DCA)' />
                        </Form.Item>
                    </Form>
                    {state.formType === "Edit"
                        ? <div>
                            <Popconfirm
                                title="Delete document type"
                                description="Are you sure to delete this document type?"
                                onConfirm={handleOnDeleteDocType}
                                okText="Yes"
                                okType="danger"
                            >
                                <Button type="primary" danger block loading={state.btnDeleteLoading}
                                    icon={<DeleteOutlined />}
                                >Delete Document Type</Button>
                            </Popconfirm>
                        </div>
                        : ""
                    }
                </div>
            </Drawer>
        </Main>
    )
}

export default DocumentType